import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { NgOptimizedImage } from '@angular/common'
@Component({
    selector: 'app-navigation-element',
    templateUrl: './navigation-element.component.html',
    styleUrls: ['./navigation-element.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavigationElementComponent {
  @Input('image') image:string | undefined;
  @Input('header') header:string | undefined;
  @Input('text') text:string | undefined;
}
